module.exports = __webpack_public_path__ + "static/media/992374.83c6a431.png";